import { Link, useNavigate, useLocation } from "react-router-dom";
import React, { useState } from "react";
import Cart from "./Cart"
import TRNDLogo from "../Assets/Images/TRND_logo.png";
import CartIcon from "../Assets/Images/Cart.png";
import { useCart } from "react-use-cart";
import { useAuth } from "../Contexts/AuthContext";
import WalkthroughModal from "../components/WalkthroughModal";

export default function Header() {
  const { isEmpty, TotalUniqueItems } = useCart();
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isCartVisible, setIsCartVisible] = useState(false);
  const [isWalkthroughModalOpen, setIsWalkthroughModalOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleCart = () => {
    setIsCartVisible(!isCartVisible);
  };

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  const isHomePage = location.pathname === '/';

  const openWalkthroughModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsWalkthroughModalOpen(true);
  };

  return (
    <>
    <header className="App-header" id="header">
        <div className="container">
          <div className="logo-section">
            <Link to="/">
          <img src={TRNDLogo} alt="TRND Logo" style={{ width: '100px', height: 'auto' }} />
        </Link>
          </div>

          <button
            type="button"
            className="hamburger"
            aria-label="Toggle navigation menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
          >
            {menuOpen ? '✕' : '☰'}
          </button>

          <nav
            className={`menu-link ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen(false)}
          >
            {/* Logged In Navigation */}
          {user ? (
            <>
                <div className="discover-dropdown">
                  <Link to="/discover">SHOP</Link>
                  <div className="dropdown-menu">
                    <Link to="/marketing-services" className="dropdown-item">
                      Shop by Categories
                    </Link>
                    <Link to="/shop-by-industry" className="dropdown-item">
                      Shop by your Industry
                    </Link>
                    <Link to="/platforms/more" className="dropdown-item">
                      Shop by Platform
                    </Link>
                    <Link to="/ai-marketing-tools" className="dropdown-item">
                      Marketing Tools
                    </Link>
                    <Link to="/marketing-genius" className="dropdown-item">
                      Marketing Genius
                    </Link>
                    <div className="dropdown-item" onClick={openWalkthroughModal}>
                      Walkthrough
                    </div>
                  </div>
                </div>
                <Link to="/marketing-genius" className="nav-link">GENIUS</Link>
                <Link to="/subscriptions-plans" className="nav-link">PLANS & PRICING</Link>
                <Link to="/resources" className="nav-link">RESOURCES</Link>
              </>
            ) : (
              /* Not Logged In Navigation */
              <>
                {/* Show HOME link only when not on home page */}
                {!isHomePage && (
                  <Link to="/" className="nav-link">HOME</Link>
                )}
                <div className="discover-dropdown">
                  <Link to="/discover">DISCOVER</Link>
                  <div className="dropdown-menu">
                    <Link to="/marketing-services" className="dropdown-item">
                      Shop by Categories
                    </Link>
                    <Link to="/shop-by-industry" className="dropdown-item">
                      Shop by your Industry
                    </Link>
                    <Link to="/platforms/more" className="dropdown-item">
                      Shop by Platform
                    </Link>
                    <Link to="/ai-marketing-tools" className="dropdown-item">
                      Marketing Tools
                    </Link>
                    <Link to="/marketing-genius" className="dropdown-item">
                      Marketing Genius
              </Link>
                    <div className="dropdown-item" onClick={openWalkthroughModal}>
                      Walkthrough
                    </div>
                  </div>
                </div>
                <Link to="/subscriptions-plans" className="nav-link">PLANS & PRICING</Link>
                <Link to="/resources" className="nav-link">RESOURCES</Link>
              </>
            )}
          </nav>

          <div className="cart-actions">
            <div className="cart-button" onClick={toggleCart}>
                <img src={CartIcon} alt="Cart" style={{ width: '24px', height: 'auto' }} />
                {!isEmpty && (
                  <span style={{ 
                    position: 'absolute', 
                    top: '-8px', 
                    right: '-8px',
                    background: '#e94560', 
                    color: 'white',
                    borderRadius: '50%',
                    width: '18px',
                    height: '18px',
                    fontSize: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center' 
                  }}>
                    {TotalUniqueItems}
                  </span>
                )}
              </div>
            {user ? (
              <div className="action-button">
                <button className="button-touch" onClick={handleSignOut}>SIGN OUT</button>
              </div>
            ) : (
              <Link to="/login" className="action-button">
                <button className="button-touch">LOGIN</button>
              </Link>
            )}
          </div>
        </div>
        {isCartVisible && (
          <div style={{ position: 'absolute', right: '120px', top: '60px', zIndex: 10001 }}>
            <Cart onClose={toggleCart} />
      </div>
        )}
    </header>
      
      <WalkthroughModal 
        isOpen={isWalkthroughModalOpen} 
        onClose={() => setIsWalkthroughModalOpen(false)} 
      />
    </>
  );
}